import React from 'react';

/**
 * This wrapper component allows us to leverage an important CSS wrapper class that applies correct
 * styles to an entire tree that would normally be found in the notebook.
 */
export default function MediocreWrapper(props: {children: React.ReactNode}): JSX.Element {
  return <div className="mediocre">{props.children}</div>;
}
